module.exports = __webpack_public_path__ + "static/media/OVO.0e95afb3.png";